import React from 'react';
import Grid from '@material-ui/core/Grid';

import { Redirect } from 'react-router-dom';

class SignIn extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            waiting: false,
            redirecting: false,
            googleUser: null,
            error: null,
        };
    }

    componentDidMount() {
        if (window.document.readyState === 'complete') {
            this.onLoad();
        } else {
            window.addEventListener('load', this.onLoad);
        }
    }

    onLoad = () => {
        window.google.accounts.id.initialize({
            client_id: '139541679371-ssqhd46lkdcknrr80ok9f53dm9dk2rhs.apps.googleusercontent.com',
            callback: (result) => {
                this.startLogin(result.credential);
            },
        });
        window.google.accounts.id.renderButton(
            window.document.getElementById('google_button'),
            { theme: 'outline', size: 'large'}
        );
        window.google.accounts.id.prompt();
    }

    startLogin = (idToken) => {
        this.setState({ waiting: true });
        fetch(`/api/login?id_token=${idToken}`)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                if (result.error) {
                    window.alert(result.error);
                    this.setState({ waiting: false, error: result.error });
                } else {
                    this.setState({ waiting: false, redirecting: true });
                }
            });
    }

    render() {
        if (this.state.redirecting) {
            let url = '/';
            if (window.location.search) {
                for (let pair of window.location.search.substring(1).split('&')) {
                    const values = pair.split('=');
                    if (values.length === 2 && values[0] === 'url') {
                        url = decodeURIComponent(values[1]);
                    }
                }
            }
            return (<Redirect to={url} />);
        }
        return (
            <Grid
                justify="center"
                alignItems="center" container style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}>
                <Grid item>
                    <h2>Wild Sky Support</h2>
                    <div id="google_button"></div>
                    {
                        this.state.error &&
                        <div style={{ color: 'red' }}>
                            {this.state.error}
                        </div>
                    }
                </Grid>
            </Grid>
        );
    }
}

export default SignIn;
